@if (training) {
  <div class="hover-content-wrapper" #dialog [@fadeInOnEnter] [@fadeOutOnLeave]>
    <div class="card-header d-flex align-items-center justify-content-between py-2 px-3">
      <h2 class="mb-0" translate>TRAININGS.COURSE_CONTENT</h2>
      <button mat-icon-button (click)="close()">
        <mat-icon svgIcon="close_v2"></mat-icon>
      </button>
    </div>
    @if (training.lead_video) {
      <div class="video-section mb-3">
        <app-video [video]="training.lead_video" [autoplay]="true"></app-video>
      </div>
    }
    <div class="content px-4">
      <h1>{{training.name}}</h1>
      <div class="d-flex align-items-center mb-md-2 training-meta">
        @if (training.trainers.length > 0) {
          <div class="trainers">
            <mat-icon svgIcon="trainer_v2"></mat-icon>
            @for (trainer of training.trainers; track trainer) {
              <span class="trainer-name"> {{trainer.name}} </span>
            }
          </div>
        }
        @if (training.duration) {
          <app-training-duration color="accent" class="d-flex" [duration]="training.duration">
          </app-training-duration>
        }
        <div>
          <mat-icon svgIcon="language_v2" class="me-2"></mat-icon>
          <span translate>{{getLanguageHeader()}}</span>
        </div>
      </div>
      @if (training.learnings?.length > 0) {
        <div class="card-content training-keypoints d-flex flex-column mt-4">
          @for (learning of training.learnings; track learning) {
            <span class="training-highlight d-flex my-2">
              <mat-icon svgIcon="check_v2" class="me-2"></mat-icon>
              {{learning}}
            </span>
          }
        </div>
      }
      <div class="footer d-flex align-items-center justify-content-end">
        <a [routerLink]="getTrainingLink(training.slug)" mat-raised-button color="primary" class="enter-training" [disabled]="showPreview" mat-dialog-close>
          <span translate>TRAININGS.BUTTON.START</span>
        </a>
      </div>
    </div>
  </div>
}
